// extracted by mini-css-extract-plugin
module.exports = {"text-warning":"text-warning__hjhDE","loading":"loading__K2Fqo","icon":"icon__jxtSy","button-loader":"button-loader__gkxIe"};